import React from "react"

export default function TypeDropDownGrouped({ value }) {
  return <div>{value} </div>
}
